export default function slideScale(imagesTl, optionsAnimImages, sectionName) {
  imagesTl
    .from(`.${sectionName}-image-${optionsAnimImages.firstImageToAnimate}`, {
      xPercent: optionsAnimImages.xPercent,
    })
    .from(`.${sectionName}-image-${optionsAnimImages.lastImageToAnimate}`, {
      delay: optionsAnimImages.delayScale,
      opacity: optionsAnimImages.opacity,
      scale: optionsAnimImages.scale,
      xPercent: optionsAnimImages.xScale,
      yPercent: optionsAnimImages.yScale,
      duration: optionsAnimImages.duration,
    });
}
